import { defineComponent } from 'vue';
import ListFilterPopover from '@/components/root-component/list-filter-popover/list-filter-popover.vue';
import { useMgaReportListFilterStore } from '@/store/mga-reports/mga-report-list-filter.store';
import { ReportListFilterFields } from '@/models/report/report-list-filter.model';
import { storeToRefs } from 'pinia';
import { useCountryListStore } from '@/store/dictionary/country-list.store';
import { useCurrencyListStore } from '@/store/dictionary/currency-list.store';
import { useGameTypeListStore } from '@/store/dictionary/game-type-list.store';
import { useGameCategoryListStore } from '@/store/dictionary/game-category-list.store';
import { useMgaReportListStore } from '@/store/mga-reports/mga-report-list.store';
import { isEqual } from 'lodash';
import { GROUP_BY_OPTIONS } from '@/models/app-common/app-common.model';

export default defineComponent({
  name: 'MgaReportListFilter',
  components: { ListFilterPopover },
  setup() {
    const mgaReportListStore = useMgaReportListStore();
    const { isReportListLoading } = storeToRefs(mgaReportListStore);
    const { getReportList } = mgaReportListStore;
    const mgaReportListFilterStore = useMgaReportListFilterStore();
    const {
      isFilterVisible,
      isFilterActive,
      filterFormData,
      activeFiltersCount,
      submittedFilterFormData,
    } = storeToRefs(mgaReportListFilterStore);
    const {
      setFilterFormData,
      resetFilterFormData,
      setIsFilterVisible,
    } = mgaReportListFilterStore;

    const countryListStore = useCountryListStore();
    const { countryList, isCountryListLoading } = storeToRefs(countryListStore);

    const currencyListStore = useCurrencyListStore();
    const { currencyList, isCurrencyListLoading } = storeToRefs(currencyListStore);

    const gameTypeListStore = useGameTypeListStore();
    const {
      gameTypeList,
      isGameTypeListLoading,
    } = storeToRefs(gameTypeListStore);

    const gameCategoryListStore = useGameCategoryListStore();
    const { gameCategoryList, isGameCategoryListLoading } = storeToRefs(gameCategoryListStore);

    const closeFilter = (): void => {
      if (!isEqual(filterFormData.value, submittedFilterFormData.value)) {
        filterFormData.value = { ...submittedFilterFormData.value };
      }
      setIsFilterVisible(false);
    };

    const submitFilter = (): void => {
      setFilterFormData();
      getReportList();
    };

    const resetFilter = (): void => {
      resetFilterFormData();
      getReportList();
    };

    return {
      isFilterVisible,
      isFilterActive,
      isReportListLoading,
      closeFilter,
      GROUP_BY_OPTIONS,
      filterFormData,
      activeFiltersCount,
      countryList,
      isCountryListLoading,
      currencyList,
      isCurrencyListLoading,
      gameTypeList,
      isGameTypeListLoading,
      gameCategoryList,
      isGameCategoryListLoading,
      ReportListFilterFields,
      submitFilter,
      resetFilter,
    };
  },
});
